import axios from './axios'

function service(endpoint) {

    function launch(filters) {
        return axios.post(`${endpoint}/launch`, filters).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        launch
    }
}

export default service
